module.exports = __webpack_public_path__ + "images/program/chest.eea90e32.svg";